import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { StatusFilter } from "@/hooks/dashboard/useSessionFilters";
import { useTranslation } from "react-i18next";

interface SessionsFilterProps {
  statusFilter: StatusFilter;
  onStatusChange: (status: StatusFilter) => void;
}

export function SessionsFilter({ statusFilter, onStatusChange }: SessionsFilterProps) {
  const { t } = useTranslation();
  
  const statuses: Array<{ value: StatusFilter; label: string }> = [
    { value: "all", label: t("sessions.allStatuses") },
    { value: "active", label: t("sessions.active") },
    { value: "historic", label: t("sessions.historic") },
  ];

  return (
    <div className="flex items-center gap-2">
      <Select
        value={statusFilter}
        onValueChange={(value) => onStatusChange(value as StatusFilter)}
      >      <SelectTrigger className="w-[180px]">
          <SelectValue placeholder={t("sessions.statusFilter")} />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {statuses.map((status) => (
              <SelectItem key={status.value} value={status.value}>
                {status.label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
}
